"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MisDatosForm = void 0;
var react_1 = __importStar(require("react"));
var text_field_1 = require("../../ui/text-field");
var buttons_1 = require("../../ui/buttons");
var index_css_1 = __importDefault(require("./index.css"));
var recoil_1 = require("recoil");
var login_1 = require("../../hooks/login");
var api_1 = require("../../lib/api");
var react_router_dom_1 = require("react-router-dom");
function MisDatosForm() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_1.useState)(false), showMessage = _a[0], setShowMessage = _a[1];
    var _b = (0, react_1.useState)(false), showMessagePassword = _b[0], setShowMessagePassword = _b[1];
    var setToken = (0, recoil_1.useSetRecoilState)(login_1.token);
    var tokenValue = (0, recoil_1.useRecoilValue)(login_1.token);
    var _c = (0, react_1.useState)(""), userFullName = _c[0], setUserFullName = _c[1];
    var _d = (0, react_1.useState)(""), userEmail = _d[0], setUserEmail = _d[1];
    (0, react_1.useEffect)(function () {
        (0, api_1.fetchUserData)(tokenValue).then(function (user) {
            setUserEmail(user.email);
            setUserFullName(user.fullName);
        });
    }, []);
    function uptadeUserHandler(e) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, name, password, confirmation, updated, token_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        setShowMessagePassword(false);
                        setShowMessage(false);
                        formData = new FormData(e.target);
                        name = formData.get("name");
                        password = formData.get("password");
                        confirmation = formData.get("confirmation");
                        if (!name) {
                            setShowMessage(true);
                            return [2 /*return*/];
                        }
                        if (password != confirmation) {
                            setShowMessagePassword(true);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, (0, api_1.fetchUpdateUser)(userEmail, name, password)];
                    case 1:
                        updated = _a.sent();
                        if (!(updated && password != "")) return [3 /*break*/, 3];
                        return [4 /*yield*/, (0, api_1.fetchLogin)(userEmail, password)];
                    case 2:
                        token_1 = _a.sent();
                        if (token_1) {
                            setToken(token_1);
                            navigate("/");
                        }
                        _a.label = 3;
                    case 3:
                        if (updated && password == "") {
                            navigate("/");
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    return (react_1.default.createElement("form", { onSubmit: uptadeUserHandler, className: index_css_1.default["mis-datos-form-container"] },
        react_1.default.createElement(text_field_1.TextField, { label: "EMAIL", name: "email", type: "text", disabled: true, defaultValue: userEmail }),
        react_1.default.createElement(text_field_1.TextField, { label: "NOMBRE", name: "name", type: "text", defaultValue: userFullName }),
        react_1.default.createElement(text_field_1.TextField, { label: "CONTRASEÑA", name: "password", type: "password" }),
        react_1.default.createElement(text_field_1.TextField, { label: "REPETIR CONTRASEÑA", name: "confirmation", type: "password" }),
        showMessage ? (react_1.default.createElement("p", { className: index_css_1.default["error-message"] }, "El campo del nombre no puede quedar vacio")) : (""),
        showMessagePassword ? (react_1.default.createElement("p", { className: index_css_1.default["error-message"] }, "Las contrase\u00F1as no coinciden")) : (""),
        react_1.default.createElement("div", { className: index_css_1.default["button-container"] },
            react_1.default.createElement(buttons_1.MainButton, { color: "pink" }, "GUARDAR"))));
}
exports.MisDatosForm = MisDatosForm;
